export type NotificationPermissionState =
  | "not_requested"
  | "provisional"
  | "limited"
  | "authorized"
  | "denied"
  | "restricted"
  | "unsupported";

export type PushTokenResolutionState =
  "idle" | "pending" | "resolved" | "failed";

export type PushTokenRegistrationState =
  "idle" | "pending" | "registered" | "failed";

export type NotificationDeliverabilityStatus =
  | "not_requested"
  | "denied"
  | "restricted"
  | "unsupported"
  | "token_registration_pending"
  | "token_registered"
  | "token_rejected"
  | "backend_registration_failed";

export type NotificationDeliverabilityInputs = {
  permissionState: NotificationPermissionState;
  tokenResolutionState: PushTokenResolutionState;
  tokenRegistrationState: PushTokenRegistrationState;
};

export function isNotificationPermissionAvailable(
  permissionState: NotificationPermissionState,
): boolean {
  return ["provisional", "limited", "authorized"].includes(permissionState);
}

/**
 * Resolve the patient-facing device state without conflating it with the
 * account preference. A saved preference remains independent when this
 * device cannot deliver a push.
 */
export function getNotificationDeliverabilityStatus({
  permissionState,
  tokenResolutionState,
  tokenRegistrationState,
}: NotificationDeliverabilityInputs): NotificationDeliverabilityStatus {
  if (
    permissionState === "not_requested" ||
    permissionState === "denied" ||
    permissionState === "restricted" ||
    permissionState === "unsupported"
  ) {
    return permissionState;
  }

  if (tokenResolutionState === "failed") return "token_rejected";
  if (tokenResolutionState === "pending") {
    return "token_registration_pending";
  }

  if (tokenRegistrationState === "failed") {
    return "backend_registration_failed";
  }
  if (
    tokenRegistrationState === "pending" ||
    tokenRegistrationState === "idle"
  ) {
    return "token_registration_pending";
  }

  return "token_registered";
}
